import {LegacySponsorAdaptor} from './legacySponsorAdaptor.js';
import {LegacyInviterAdaptor} from './legacyInviterAdaptor.js';
import {LegacyPhoneListAdaptor} from './legacyPhoneListAdaptor.js';
import {LegacyPersonalInfoAdaptor} from './legacyPersonalInfoAdaptor.js';
import {LegacyCommPreferencesAdaptor} from './legacyCommPreferencesAdaptor.js';
import {LegacyPrivacyOptionInfoAdaptor} from './legacyPrivacyOptionInfoAdaptor.js';

export var LegacyPersonAdaptor = function(personData, sponsor, inviter) {
    var person = {};
    
    // Constructor
    if (personData) {
        var firstName;
        var lastName;
        var aName = personData.names.getAName();
        if (aName) {
            firstName = aName.given;
            lastName = aName.family;
        }
        person.header = {
            accountID: personData.accountID,
            firstName: firstName,
            lastName: lastName,
            preferredName: personData.preferredName,
            profileImageUrl: personData.profilePictureUrl,
            profileThumbnailUrl: personData.profileThumbnailUrl,
            personID: personData.id,
            personType: personData.type,
            fID: personData.fID,
            termsAndConditions: personData.termsAndConditions,
            sponsor: undefined,
            inviter: undefined
        };

        if (sponsor) {
            person.header.sponsor = LegacySponsorAdaptor(sponsor);
        }
        
        if (inviter) {
            person.header.inviter = LegacyInviterAdaptor(inviter);
        }

        person.contactInfo = {
            email: personData.email,
            phoneList: LegacyPhoneListAdaptor(personData.phoneNumbers)
        };

        person.address = personData.addresses.getAnAddress();

        person.personalInfo = LegacyPersonalInfoAdaptor(personData);

        person.commPreferences = LegacyCommPreferencesAdaptor(personData);

        person.privacyOptionInfo = LegacyPrivacyOptionInfoAdaptor(personData.preferences);
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------

    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------

    return person;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/adaptors/legacyPersonAdaptor.js
// module id = 196
// module chunks = 0